<template>
  <div class="not-found">
    <h1>Página não encontrada</h1>
    <p>A página que você está procurando não foi encontrada.</p>
  </div>
</template>

<style scoped>
.not-found {
  text-align: center;
  margin-top: 50px;
}
</style>
